import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Dialog from 'mineral-ui/Dialog';
import ModalBody from './ModalBody';
import ModalFooter from './ModalFooter';
import sumoLogger from '../../Logger';

/*
 * Note this was mostly a wrapper of the MineralUI Dialog
 * The interface is mostly the same, except modeless is disabled,
 * as it does not follow our design principles.
 * However, please see the comment below about why MineralUI Dialog does not quit work
 */
const propTypes = {
  actions: PropTypes.arrayOf(PropTypes.object),
  children: PropTypes.node.isRequired,
  modeless: PropTypes.bool,
  title: PropTypes.node.isRequired,
  footer: PropTypes.string,
};

const defaultProps = {
  actions: undefined,
  modeless: undefined,
  footer: undefined,
};

export default class Modal extends Component {
  /*
   * MineralUI does a findByType on it's children which makes
   * tweeking the interface more hassle than it is worth
   * (we could do the same and then just replace them with the Dialog type)
   * If more advance dialogs are needed in the future, then we
   * may need to switch to just using Dialog directly (or implementing our own,
   * though getting accessibility right for dialogs is big pain).
   * Refer to https://assortment.io/posts/accessible-modal-component-react-portals-part-1
   * for accessibiliy guidelines and implementation.
   *
   * After some more debugging, it seems that matching by type even fails when using the dialog
   * directly in our setup. Using the same MineralUI dependencies in codesandbox works, so it
   * is something with our setup. As such, until it is worth implementing our own (or switching
   * to using react-modal (https://www.npmjs.com/package/react-modal)) we will just place everything
   * in the body of the Dialog. We implement our own footer to right align the actions at the
   * bottom, but this means that scrolling will not work correctly for extremely large body
   * contents.
   *
   * static Actions = DialogActions;
   *
   * static Body = DialogBody;
   *
   * static Footer = DialogFooter;
   *
   * static Header = DialogHeader;
   *
   * static Title = DialogTitle;
   */
  static Body = ModalBody;

  static Footer = ModalFooter;

  render() {
    const {
      actions,
      modeless,
      children,
      footer,
      ...rest
    } = this.props;

    if (actions) {
      sumoLogger.error('Do not use actions, they do not work in our current setup. See Modals source comments.');
    }
    if (modeless) {
      sumoLogger.error('Do not use modeless, it will be ignored.');
    }

    // By default it will place everything in the body
    return (
      <Dialog {...rest} appSelector="#root" showCloseButton>
        {children}
      </Dialog>
    );
  }
}

Modal.propTypes = propTypes;
Modal.defaultProps = defaultProps;
